module.exports = __webpack_public_path__ + "img/ESAF.1cc93410.jpg";